import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '../../services/locale.service';

@Pipe({
    name: 'localizedEstDateTime',
    pure: false
})
export class LocalizedEstDateTimePipe implements PipeTransform {
    constructor(private localeService: LocaleService) {}

    transform(value: Date | string, format = 'dd.MM.yyyy HH:mm'): string {
        return new DatePipe(this.localeService.locale || 'en').transform(value, format);
    }
}
